import $ from 'jquery';


toggleButtonBar();
$(document).on('scroll', function () {
    toggleButtonBar();
});

function toggleButtonBar() {
    if ($('.slider__links').length > 0) {
        if($(document).scrollTop() < $('.slider__links').offset().top + $('.slider__links').height()) {
            $('.button-bar').addClass('button-bar--hide');
        } else {
            $('.button-bar').removeClass('button-bar--hide');
        }
    } else {
        $('.button-bar').removeClass('button-bar--hide');
    }
}
